export const API_BASE_URL = '/api';
// export const MOBIZ_API_URL = 'https://api.mobiz.posturinn.is/';
// 'http://localhost:58954/'

const mobizUrlFromEnv = process.env.REACT_APP_MOBIZ_API_URL;

export const MOBIZ_API_URL = process.env.NODE_ENV === 'development' ? mobizUrlFromEnv : 'PLACEHOLDER_MOBIZ_API_URL';

// Mobiz routes
export const VERIFY_SOCIALID_URL = 'account/identification-number/verification/';
export const RESET_PASSWORD_URL = 'api/v1/account/user/reset-password';
export const VERIFY_EMAIL = 'account/email/verification/';
export const VERIFY_FOREIGN_POSTCODE = 'api/v1/verify/postal-code';
export const VERIFY_EMAIL_URL = 'api/v1/verify/email';
export const LABEL = 'api/v1/shipments/{shipmentId}/label?senderNiN={senderNin}&registrationKey={registrationKey}';
export const MOBIZ_VERIFY_EMAIL = 'account/email/verification/';
export const MOBIZ_AUDKENNI_VERIFICATION_CODE = 'api/v1/e-cert-verification-code';

// Get routes
export const HOMES_AND_COMPANIES_URL = MOBIZ_API_URL + 'api/v1/homes-and-companies';
export const LETTER_POSTBOXES_URL = MOBIZ_API_URL + 'api/v1/letter-postboxes';
export const SERVICE_LEVEL_URL = MOBIZ_API_URL + 'api/v1/locations/servicelevel';
export const AVAILABLE_JOBS = 'api/v1/available-jobs';
export const POSTBOXES = MOBIZ_API_URL + 'api/v1/locations?locationTypes=PostBox';
export const POSTOFFICES = MOBIZ_API_URL + 'api/v1/locations?locationTypes=PostOffice';

// Shipment
export const GET_SHIPMENT = MOBIZ_API_URL + 'api/v1/shipments/{shipmentId}';
export const SUBMIT_DOMESTIC = '/postshipment/domestic';
export const SUBMIT_INTERNATIONAL = '/postshipment/international';
export const SHIPMENT_PDF = '/postshipment/pdf';
export const REDIRECT_SHIPMENT = MOBIZ_API_URL + 'api/v1/redirect-full-postbox-delivery';
export const INQUIRY_POSTREQ = MOBIZ_API_URL + 'api/v1/inquiry-form';

// Forms postfix
export const COMPANY_DEBIT_FORM = MOBIZ_API_URL + 'api/v1/company-letter-registration';
export const COMPANY_DEBIT_FORM_PDF = MOBIZ_API_URL + 'api/v1/company-letter-registration-pdf/';
export const DAMAGE_REPORT = '/damagereport';
export const SEND_RECEIPT_EXPRESS_SERVICES = MOBIZ_API_URL + 'api/v1/customs/express-services';
export const SEND_RECEIPT = MOBIZ_API_URL + 'api/v1/shipments/customsInfo';
export const POST_TO_MAILCHIMP = MOBIZ_API_URL + 'api/v1/newsletter';
export const CUSTOMER_OPINIONS_FORM = MOBIZ_API_URL + 'api/v1/customer-feedback';
export const DAMAGE_REPORT_POST = MOBIZ_API_URL + 'api/v1/damage-report';
export const DAMAGE_REPORT_VALIDATE_TN = MOBIZ_API_URL + 'api/v1/damage-report/trackingnumber';

// Validation postfix
export const VALIDATION_COMPANY_SOCIALID = MOBIZ_API_URL + 'api/v1/company-identification-number-validation';
export const VALIDATION_SOCIALID = MOBIZ_API_URL + 'api/v1/identification-number-validation';
export const VALIDATION_POSTCODE = '/validation/postcode';
export const VALIDATION_COD = '/validation/cod';

// Captcha
export const CAPTCHA = '/captcha';

// API outside our regular API
export const ADDRESS_AUTOCOMPLETE_URL = MOBIZ_API_URL + 'api/v1/street-lookup/autocomplete';
export const ADDRESS_GET = MOBIZ_API_URL + 'api/v1/street-lookup';

// Umbraco urls
export const AUTOCOMPLETE = '/umbraco/Surface/Search/GetAllPages';
export const DO_SEARCH = '/umbraco/Surface/Search/DoSearch';
export const HOME_DELIVERY = '/umbraco/Surface/HomeDelivery/Post';
export const POSTBOX_DELIVERY = '/umbraco/Surface/PostboxDelivery/Post';
export const CONTACT = '/umbraco/Surface/Contact/Post';
export const INQUIRY_POST = '/umbraco/Surface/Inquiry/Post';

export const JOBS_APPLICATION_URL = 'https://postur.umsokn.is';

// REGISTER SHIPMENT FEEDBACK
export const REGISTER_SHIPMENT_FEEDBACK = MOBIZ_API_URL + 'api/v1/shipments/feedback';

// TODO
export const CHAT_BOT_AUTHENTICATION = 'https://audkenni-service.prod.posturinn.is/authentication/chatbot';
